import React, { useState } from 'react'
import {
  Datagrid,
  List,
  TextField,
  useDataProvider,
  useNotify,
  useRefresh,
} from 'react-admin'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField as MuiTextField } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'

const CreateLevelDialog = ({ open, onClose }) => {
  const dataProvider = useDataProvider()
  const notify = useNotify()
  const refresh = useRefresh()
  const [title, setTitle] = useState('')
  const [saving, setSaving] = useState(false)

  const handleSave = async () => {
    if (!title.trim()) return
    setSaving(true)
    try {
      await dataProvider.create('tournament_levels', { data: { title: title.trim() } })
      notify('Уровень турнира создан', 'info')
      setTitle('')
      onClose()
      refresh()
    } catch (error) {
      notify(error?.message || 'Не удалось создать уровень турнира', 'warning')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} fullWidth maxWidth='sm'>
      <DialogTitle>Новый уровень турнира</DialogTitle>
      <DialogContent>
        <MuiTextField
          label='Название уровня'
          fullWidth
          autoFocus
          value={title}
          onChange={(event) => setTitle(event.target.value)}
          helperText='Например: Чемпионат России'
          margin='normal'
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Отмена</Button>
        <Button onClick={handleSave} color='primary' variant='contained' disabled={!title.trim() || saving}>
          Создать
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const CreateLevelButton = () => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Button color='primary' variant='contained' startIcon={<AddIcon />} onClick={() => setOpen(true)}>
        Создать уровень турнира
      </Button>
      <CreateLevelDialog open={open} onClose={() => setOpen(false)} />
    </>
  )
}

const ListActions = () => (
  <div style={{ display: 'flex', justifyContent: 'flex-end', flex: 1 }}>
    <CreateLevelButton />
  </div>
)

const ListTournamentLevels = (props) => (
  <List title='Рейтинговые баллы' {...props} exporter={false} actions={<ListActions />}>
    <Datagrid rowClick='show'>
      <TextField source='title' label='Название уровня турнира' />
    </Datagrid>
  </List>
)

export default ListTournamentLevels
